import React from 'react';

import CarSelectionHelperCard from '@/components/CarSelectionHelperCard';
import { CarsListItem } from '@/modules/CarsStock/components/common.styles';
import { useTypedSelector } from '@/store/store';
import { getCarListView } from '@/store/reducers/cars-stock';
import { useCarSelectionHelper } from '@/hooks/useCarSelectionHelper';

function CarSelectionHelper() {
  const { image, openModal } = useCarSelectionHelper();
  const view = useTypedSelector(getCarListView);

  if (!image || !image.url || view === 'landscape') {
    return null;
  }

  return (
    <CarsListItem view="portrait">
      <CarSelectionHelperCard image={image} onClick={openModal} />
    </CarsListItem>
  );
}

export default CarSelectionHelper;
